import React, { Component } from 'react';
import { Header } from 'semantic-ui-react';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { profileSelector } from '../../selectors';
class UsernameAndPassword extends Component {
	constructor(props) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		e.preventDefault();
		const { actions } = this.props;
		actions.push(e.target.parentNode.href);
	}

	render() {
		const { profile } = this.props;
		return (
			<div>
				<Header as='h3' content='Username (email address)' color='red' />
				<div style={{ display: 'flex' }}>
					<Header as='h4' content={profile.email} style={{ marginRight: '15px' }} /> <Header as='h4' content='edit' style={{ color: '#4183c4', cursor: 'pointer', marginTop: "0px" }} onClick={() => this.props.actions.push('/profile/security/username')} />
				</div>
				<Header as='h3' content='Password' color='red' />
				<div style={{ display: 'flex' }}>
					<Header as='h4' content='**********' style={{ marginRight: '15px' }} /> <Header as='h4' content='edit' style={{ color: '#4183c4', cursor: 'pointer', marginTop: "0px" }} onClick={() => this.props.actions.push('/profile/security/password')} />
				</div>
			</div>
		);
	}
}

UsernameAndPassword.propTypes = {};

const mapStateToProps = state => {
	return {
		profile: profileSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		actions: {
			// ...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UsernameAndPassword);
